module.exports = __webpack_public_path__ + "img/aedifion_logo_white.7a34e3d1.png";